export default "__VITE_ASSET__D_ixIZ_Z__"